import React from 'react';

import classes from './SessionEngagementProgressBar.module.css';

const SessionEngagementProgressBar = (props) => {
    return (
        <div className={classes.ProgressBarSection}>
            <div className={classes.ProgressBarContainer}>

                {
                    props.engaging > 0
                        ? <div className={[classes.ProgressBar, classes.Engaging].join(' ')} style={{ width: props.engaging + '%' }}>
                            <span className={classes.ProgressValue}>{props.engaging}% Engaging</span>
                        </div>
                        : null
                }

                {
                    props.boring > 0
                        ? <div className={[classes.ProgressBar, classes.Boring].join(' ')} style={{ width: props.boring + '%' }}>
                            <span className={classes.ProgressValue}>{props.boring}% Boring</span>
                        </div> : null
                }
            </div>
        </div>
    );
}

export default SessionEngagementProgressBar;
